export const generateConfigurationTemplate = (
  t: (key: string) => string,
  brands: { name: string; slug: string }[]
) => [
  {
    key: "brand",
    title: t("configurationTemplate.brandTitle"),
    type: "select",
    list: [
      {
        key: "multibrand",
        title: t("configurationPage.multibrand"),
      },
      ...brands.map(({ name, slug }) => ({
        key: slug,
        title: name,
      })),
    ],
  },
  {
    key: "features",
    title: t("configurationTemplate.featuresTitle"),
    type: "checkbox",
    list: [
      {
        key: "makeup_virtual_try_on",
        title: t("configurationTemplate.featuresMakeupVirtualTryOn"),
      },
      {
        key: "camera_analysis",
        title: t("configurationTemplate.featuresCameraAnalysis"),
      },
      {
        key: "beauty_ai_advisor",
        title: t("configurationTemplate.featuresBeautyAiAdvisor"),
      },
      {
        key: "analytics",
        title: t("configurationTemplate.featuresAnalytics"),
      },
      {
        key: "makeup_transfer",
        title: t("configurationTemplate.featuresMakeupTransfer"),
      },
      {
        key: "gift_selection",
        title: t("configurationTemplate.featuresGiftSelection"),
      },
      {
        key: "skin_care",
        title: t("configurationTemplate.featuresSkinCare"),
      },
      {
        key: "products_links",
        title: t("configurationTemplate.featuresProductsLinks"),
      },
      {
        key: "redirect_to_product_page",
        title: t("configurationTemplate.featuresRedirectToProductPage"),
      },
      {
        key: "hide_sidebar",
        title: t("configurationTemplate.featuresHideSidebar"),
      },
      {
        key: "hide_hide_show",
        title: t("configurationTemplate.featuresHideHideShow"),
      },
      {
        key: "hide_cart_arrow",
        title: t("configurationTemplate.featuresHideCartArrow"),
      },
      {
        key: "use_legacy_labelling",
        title: t("configurationTemplate.featuresUseLegacyLabelling"),
      },
      {
        key: "enable_go_to_cart",
        title: t("configurationTemplate.featuresEnableGoToCart"),
      },
      {
        key: "custom_translation",
        title: t("configurationTemplate.featuresCustomTranslation"),
      },
      {
        key: "enable_iamge_upload_during_analysis",
        title: t("configurationTemplate.featuresEnableImageUploadDuringAnalysis"),
      },
    ],
  },
  {
    key: "categories",
    title: t("configurationTemplate.categoriesTitle"),
    type: "checkbox",
    list: [
      {
        key: "makeup",
        title: t("configurationTemplate.categoriesMakeup"),
      },
      {
        key: "hats",
        title: t("configurationTemplate.categoriesHats"),
      },
      {
        key: "glasses",
        title: t("configurationTemplate.categoriesGlasses"),
      },
      {
        key: "scarves",
        title: t("configurationTemplate.categoriesScarves"),
      },
      {
        key: "jewelry",
        title: t("configurationTemplate.categoriesJewelry"),
      },
      {
        key: "eye_lenses",
        title: t("configurationTemplate.categoriesEyeLenses"),
      },
      {
        key: "eyelashes",
        title: t("configurationTemplate.categoriesEyelashes"),
      },
      {
        key: "hairs",
        title: t("configurationTemplate.categoriesHairs"),
      },
    ],
  },

  // {
  //   key: "products",
  //   title: "Products categories",
  //   type: "checkbox",
  //   list: [
  //     {
  //       key: "eyeliner",
  //       title: "Eyeliner",
  //     },
  //     {
  //       key: "eyeshadow",
  //       title: "Eyeshadow",
  //     },
  //     {
  //       key: "mascara",
  //       title: "Mascara",
  //     },
  //     {
  //       key: "blush",
  //       title: "Blush",
  //     },
  //     {
  //       key: "foundation",
  //       title: "Foundation",
  //     },
  //     {
  //       key: "lipstick",
  //       title: "Lipstick",
  //     },
  //     {
  //       key: "eyebrow",
  //       title: "Eyebrow",
  //     },
  //     {
  //       key: "highlighter",
  //       title: "Highlighter",
  //     },
  //     {
  //       key: "contour",
  //       title: "Contour",
  //     },
  //     {
  //       key: "concealer",
  //       title: "Concealer",
  //     },
  //     {
  //       key: "eye_color",
  //       title: "Eye Color",
  //     },
  //     {
  //       key: "skin_smoother",
  //       title: "Skin Smoother",
  //     },
  //   ]
  // },
  {
    key: "entry",
    title: t("configurationTemplate.entryPointTitle"),
    type: "select",
    list: [
      {
        key: "best-match",
        title: t("configurationTemplate.entryPointBestMatch"),
      },
      {
        key: "gift-selection",
        title: t("configurationTemplate.entryPointGiftSelection"),
      },
      {
        key: "skin-care",
        title: t("configurationTemplate.entryPointSkinCare"),
      },
      {
        key: "makeup-transfer",
        title: t("configurationTemplate.entryPointMakeupTransfer"),
      },
    ],
  },
  {
    key: "language",
    title: t("configurationTemplate.languageTitle"),
    type: "select",
    list: [
      {
        key: "english",
        title: t("configurationTemplate.languageEnglish"),
      },
      {
        key: "portuguese",
        title: t("configurationTemplate.languagePortuguese"),
      },
      {
        key: "lithuanian",
        title: t("configurationTemplate.languageLithuanian"),
      },
      {
        key: "spanish",
        title: t("configurationTemplate.languageSpanish"),
      },
      {
        key: "french",
        title: t("configurationTemplate.languageFrench"),
      },
      {
        key: "italian",
        title: t("configurationTemplate.languageItalian"),
      },
      {
        key: "german",
        title: t("configurationTemplate.languageGerman"),
      },
    ],
  },
  {
    key: "version",
    title: t("configurationTemplate.versionTitle"),
    type: "select",
    list: [
      {
        key: "standard",
        title: t("configurationTemplate.versionStandard"),
      },
      {
        key: "recommendationSystem",
        title: t("configurationTemplate.versionRecommendationSystem"),
      },
    ],
  },
]
